<template>
  <el-dialog
    width="40%"
    top="35vh"
    :visible="dialogVisible"
    @close="closeDialog"
  >
    <template #default>
      <div>Join_dialog {{ type }}</div>
    </template>
    <template #footer>
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'Details',
    props: {
      dialogVisible: {
        type: Boolean,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        form: {},
      }
    },
    methods: {
      closeDialog() {
        this.resetForm()
        this.$emit('update:dialogVisible', false)
      },
      resetForm() {},
      submit() {
        this.closeDialog()
      },
    },
  }
</script>

<style scoped lang="scss"></style>
